import React, { useEffect, useState } from "react";
import { Button, InputLabel, FormControl,spacing, Input ,Container} from "@material-ui/core";
import Todo from "./Todo";
import "./App.css";
import db from "./firebase";
import firebase from "firebase";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';


function App() {
  const [todos, setTodos] = useState([]);
  const [input, setInput] = useState("");

  // when the app loads,we need to listen to the database and fetch new todos as they get added / removed
  useEffect(() => {
    //this code here... fires when the app.js
    db.collection("todos")
      .orderBy("timestamp", "desc")
      .onSnapshot((snapshot) => {
        setTodos(
          snapshot.docs.map((doc) => ({ id: doc.id, todo: doc.data().todo }))
        );
      });
  }, []);

  const addTodo = (event) => {
    //this will fire off when we click the button
    event.preventDefault(); //will stop the refres
    db.collection("todos").add({
      todo: input,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    });

    setInput("");
  };
  
  

  

  return (
    
        
    <div className="App">
      
      <Container fixed justify="center" >
      
      <Grid Container justify="center" >
      <Grid container  spacing={6}>
      <Grid item m={12}>
    <h1>Hey dev, have Good day</h1>



      <form>
        <FormControl>
          <InputLabel>✍️ Write a TODO:</InputLabel>
          <Input
            value={input}
            onChange={(event) => setInput(event.target.value)}
          />
        </FormControl>

        <Button
          type="submit"
          color="primary"
          disabled={!input}
          onClick={addTodo}
          variant="contained">
          Add TODO
        </Button>
      </form>
      <div justify="center">
      <ul justify="center" >
        {todos.map((todo) => (
          <Todo todo={todo} />
        ))}
      </ul>
      </div>
      </Grid></Grid>
      </Grid>
      </Container>
          </div>
  );
}

export default App;
